import script from "./ThirdPartyServicesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThirdPartyServicesModal.vue?vue&type=script&setup=true&lang=ts"

import "./ThirdPartyServicesModal.vue?vue&type=style&index=0&id=7ddfde59&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ddfde59"]])

export default __exports__